// extracted by mini-css-extract-plugin
module.exports = {"page_wrapper":"PrivacyPolicy_page_wrapper__38dYh","privacy_h1":"PrivacyPolicy_privacy_h1__1y95n","privacy_description":"PrivacyPolicy_privacy_description__2yQF_"};